<aside
  class="bg-white border-r border-gray-200 shadow-sm w-72 float-left layout-main-container flex flex-col justify-between p-2 z-10 relative"
>
<div>
    <h2 class="px-3 mt-2 text-2xl font-semibold tracking-tight">{{'text.workflows' | translate}}</h2>
    <ul role="list" class="py-4 px-2 space-y-2">
      <li
        [routerLink]="'/workflow-builder/workflows'"
        [ngClass]="{
          'bg-blue-50 text-blue-600 font-medium': isActive('/workflows')
        }"
        class="cursor-pointer rounded-md"
      >
        <a
          class="hover:text-gray-600 hover:bg-gray-50 group flex gap-x-2 rounded-md p-3 text-base leading-6"
        >
          <i
            class="ti ti-git-branch text-2xl flex items-center justify-center mr-1 h-6 w-6"
          ></i>
          {{'text.all_workflows' | translate}}
        </a>
      </li>
      <li
        [routerLink]="'/workflow-builder/workflows/templates'"
        routerLinkActive="bg-blue-50 text-blue-600 font-medium"
        class="cursor-pointer rounded-md"
        (click)="isActive('/workflows/templates')"
      >
        <a
          class="hover:text-gray-600 hover:bg-gray-50 group flex gap-x-3 rounded-md p-3 text-base leading-6"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-6 w-6"
            width="18"
            height="18"
            viewBox="0 0 20 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="icon icon-tabler icons-tabler-outline icon-tabler-template"
          >
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path
              d="M4 4m0 1a1 1 0 0 1 1 -1h14a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-14a1 1 0 0 1 -1 -1z"
            />
            <path
              d="M4 12m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v6a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z"
            />
            <path d="M14 12l6 0" />
            <path d="M14 16l6 0" />
            <path d="M14 20l6 0" />
          </svg>
          {{'text.label.templates' | translate}}
        </a>
      </li>
      <li
        [routerLink]="'/workflow-builder/workflows/executions'"
        routerLinkActive="bg-blue-50 text-blue-600 font-medium"
        #rla="routerLinkActive"
        class="cursor-pointer rounded-md"
        (click)="isActive('/workflows/executions')"
      >
        <a
          class="hover:text-gray-600 hover:bg-gray-50 group flex gap-x-3 rounded-md p-3 text-base leading-6"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-6 w-6"
            width="18"
            height="18"
            viewBox="0 0 20 24"
            stroke-width="1.75"
            stroke="currentColor"
            fill="none"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
            <path d="M20.984 12.53a9 9 0 1 0 -7.552 8.355"></path>
            <path d="M12 7v5l3 3"></path>
            <path d="M19 16l-2 3h4l-2 3"></path>
          </svg>
          {{'text.execution.history' | translate}}
        </a>
      </li>
      <li
        [routerLink]="'/workflow-builder/workflows/variables'"
        routerLinkActive="bg-blue-50 text-blue-600 font-medium"
        class="cursor-pointer rounded-md"
        (click)="isActive('/workflows/variables')"
      >
        <a
          class="hover:text-gray-600 hover:bg-gray-50 group flex gap-x-3 rounded-md p-3 text-base leading-6"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            viewBox="0 0 20 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="icon icon-tabler icons-tabler-outline icon-tabler-variable text-2xl"
          >
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path
              d="M5 4c-2.5 5 -2.5 10 0 16m14 -16c2.5 5 2.5 10 0 16m-10 -11h1c1 0 1 1 2.016 3.527c.984 2.473 .984 3.473 1.984 3.473h1"
            />
            <path d="M8 16c1.5 0 3 -2 4 -3.5s2.5 -3.5 4 -3.5" />
          </svg>
          {{'text.variables' | translate}}
        </a>
      </li>
      <li
        [routerLink]="'/workflow-builder/workflows/insights'"
        routerLinkActive="bg-blue-50 text-blue-600 font-medium"
        class="cursor-pointer rounded-md"
      >
        <a
          class="hover:text-gray-600 hover:bg-gray-50 group flex gap-x-3 rounded-md p-3 text-base leading-6"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-6 w-6"
            width="18"
            height="18"
            viewBox="0 0 20 24"
            stroke-width="1.75"
            stroke="currentColor"
            fill="none"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
            <path d="M4 19l4 -6l4 2l4 -5l4 4l0 5l-16 0"></path>
            <path d="M4 12l3 -4l4 2l5 -6l4 4"></path>
          </svg>
          {{'reports.details.routes.insights' | translate}}
        </a>
      </li>
      <!-- <li>
              <a href="" class="text-gray-700 hover:text-gray-600 hover:bg-gray-50 group flex gap-x-3 rounded-md p-3 text-base leading-6">
                  <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" width="18" height="18" viewBox="0 0 20 24" stroke-width="1.75" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                      <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                      <path d="M4 8h4v4h-4z"></path>
                      <path d="M6 4l0 4"></path>
                      <path d="M6 12l0 8"></path>
                      <path d="M10 14h4v4h-4z"></path>
                      <path d="M12 4l0 10"></path>
                      <path d="M12 18l0 2"></path>
                      <path d="M16 5h4v4h-4z"></path>
                      <path d="M18 4l0 1"></path>
                      <path d="M18 9l0 11"></path>
                  </svg>
                  Settings
              </a>
          </li> -->
    </ul>
</div>
<div  class="credit-container w-full bg-blue-50 rounded-lg px-3 py-4">
    <h4 class="font-semibold text-lg text-blue-600"> {{ !rla?.isActive ? "Workflows Activated" : "Total Executions" }} </h4>
    <p  class="mt-0.5 text-gray-600 text-sm"> {{ !rla?.isActive ? "Based on your subscription" : "for this month" }} </p>
    @if(!rla?.isActive){
      <div  class="mt-2 flex justify-between">
        <span  class="text-blue-500 font-semibold">{{ totalRecords }}</span>
        <span  class="text-gray-400 font-normal">{{ limit - totalRecords }} {{'text.left' | translate}}</span>
      </div>
    }@else {
      <div  class="mt-2 flex justify-between">
        <span  class="text-blue-500 font-semibold">{{ totalExecutionRecords }}</span>
        <span  class="text-gray-400 font-normal">{{ getTotalExecutionLeft() }} {{'text.left' | translate}}</span>
      </div>
    }

    @if(!rla?.isActive) {
      <div  class="w-full bg-blue-100 rounded-full h-2.5 dark:bg-gray-700 mt-1">
        <div  
          class="bg-blue-500 h-2.5 rounded-full transition-[width]" 
          [ngStyle]="{ width: getPercentage() + '%' }"  
        ></div>
      </div>
    } @else {
      <div  class="w-full bg-blue-100 rounded-full h-2.5 dark:bg-gray-700 mt-1">
        <div  
          class="bg-blue-500 h-2.5 rounded-full transition-[width]" 
          [ngStyle]="{ width: getExecutionPercentage() + '%' }"  
        ></div>
      </div>    
    }

    <p class="text-gray-600 mt-3 text-sm" *ngIf="rla?.isActive">
        {{'text.resets_on' | translate}} {{ currentDate | dateformat }}
    </p>
</div>

</aside>
